import React from "react";
import { motion } from "framer-motion";
import { Linkedin } from "lucide-react";

function MentorAndTeam() {
  const team = [
    {
      name: "Dhrutidhara Behera",
      role: "CEO & CTO",
      img: "/ddb.jpeg" ,
      linkedin: "https://www.linkedin.com/in/ddbehera01/",
    },
    {
      name: "Subrajit Nayak",
      role:"Admin ",
      img: "/sn.jpeg",
      linkedin: "https://www.linkedin.com/in/subrajit-nayak-ba22732a6/?originalSubdomain=in",
    },
  ];

  return (
    <section className="relative bg-gradient-to-b from-[#0A2A43] via-[#1E90FF] to-[#87CEEB] text-white py-20">
      <div className="max-w-6xl mx-auto px-6">

        {/* Title */}
        <motion.h2
          className="text-4xl md:text-5xl font-extrabold text-center mb-6"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Our <span className="text-blue-200">Leaders</span>
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          className="text-center text-blue-100 max-w-2xl mx-auto mb-14 text-lg"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          A small, focused team driving innovation in robotics, AI, and intelligent automation.
        </motion.p>

        {/* TEAM CARDS */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 gap-12"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {team.map((member, index) => (
            <motion.div
              key={index}
              className="bg-blue-600/80 rounded-3xl p-10 shadow-xl border border-blue-300 text-center"
              whileHover={{ y: -8 }}
            >
              <img
                src={member.img}
                alt={member.name}
                className="w-32 h-32 mx-auto rounded-full border-4 border-blue-200 shadow-md object-cover mb-6"
              />

              <h3 className="text-2xl font-bold">{member.name}</h3>
              <p className="text-blue-100 mb-4">{member.role}</p>

              {/* LinkedIn */}
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-full bg-white/10 hover:bg-white/20 transition"
              >
                <Linkedin className="w-5 h-5 text-blue-200" />
                <span className="text-sm text-blue-100">LinkedIn</span>
              </a>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}

export default MentorAndTeam;
